var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.type == 'calendly' && !_vm.calendly)?_c('i',{staticClass:"icon-calendar text-danger"}):_vm._e(),(_vm.calendly)?_c('span',[(_vm.calendly == '')?_c('small',{staticClass:"text-danger"},[(_vm.workspace_email)?_c('i',{staticClass:"icon-calendar mr-1"}):_vm._e()]):_c('small',{staticClass:"text-success"},[_vm._v("\n      "+_vm._s(_vm.calendly)+"\n    ")])]):_vm._e(),(_vm.stats !== undefined)?_c('div',[_vm._l((_vm.stats[_vm.user_id].available_contacts),function(available_contacts,key){return (
        _vm.type == 'campaigns' &&
        _vm.stats[_vm.user_id].available_contacts !== undefined &&
        (_vm.target_id == 0 || _vm.target_id == _vm.stats[_vm.user_id].targets[key])
      )?_c('div',[_c('a',{attrs:{"target":"_blank","href":_vm.getCampaignSearch(_vm.stats[_vm.user_id].campaign_names[key])}},[_c('span',{staticClass:"badge rounded text-white",class:_vm.getClassAvailable(
              available_contacts,
              _vm.stats[_vm.user_id].campaign_status[key],
              _vm.stats[_vm.user_id].quantity_per_day[key],
              _vm.stats[_vm.user_id].warning_apollo[key]
            )},[_vm._v("\n          "+_vm._s(_vm.stats[_vm.user_id].campaign_names[key])+"\n          "),_c('i',{staticClass:"icon-checkmark ml-1",attrs:{"title":"available contacts"}}),_vm._v("\n          "+_vm._s(available_contacts)+"\n          "),_c('i',{staticClass:"icon-user-plus ml-1",attrs:{"title":"new contacts per day"}}),_vm._v("\n          "+_vm._s(_vm.stats[_vm.user_id].quantity_per_day[key])+"\n\n          "),(false)?_c('span',[_c('i',{staticClass:"icon-search ml-1",attrs:{"title":"visible contacts"}}),_vm._v("\n            "+_vm._s(_vm.stats[_vm.user_id].visible_contacts[key])+"\n          ")]):_vm._e(),(_vm.stats[_vm.user_id].new_emails_sent_today)?_c('span',[_c('i',{staticClass:"icon-email ml-1",attrs:{"title":"new engaged today"}}),_vm._v("\n            "+_vm._s(_vm.stats[_vm.user_id].new_emails_sent_today[key])+"\n          ")]):_vm._e(),(_vm.stats[_vm.user_id].recurring_emails_sent_today)?_c('span',[_c('i',{staticClass:"icon-refresh ml-1",attrs:{"title":"follow ups today"}}),_vm._v("\n            "+_vm._s(_vm.stats[_vm.user_id].recurring_emails_sent_today[key])+"\n          ")]):_vm._e(),(_vm.stats[_vm.user_id].emails_sent_b)?_c('span',[_c('i',{staticClass:"icon-user ml-1",attrs:{"title":"total contacts"}}),_vm._v("\n            "+_vm._s(_vm.stats[_vm.user_id].emails_sent_b)+"\n          ")]):_vm._e()])])]):_vm._e()}),(_vm.type == 'deliverability')?_c('span',{},[_vm._v(_vm._s(_vm.getPercentage(_vm.stats[_vm.user_id].bounce_total, _vm.stats[_vm.user_id].emails_sent))+"\n      %\n      "),_c('div',[(
            _vm.calcKPI(
              _vm.getPercentage(
                _vm.stats[_vm.user_id].bounce_total_7,
                _vm.stats[_vm.user_id].emails_sent_7
              ),
              _vm.getPercentage(
                _vm.stats[_vm.user_id].bounce_total_15,
                _vm.stats[_vm.user_id].emails_sent_15
              )
            ) != 0
          )?_c('div',{class:_vm.getColorKPI(
              _vm.calcKPI(
                _vm.getPercentage(
                  _vm.stats[_vm.user_id].bounce_total_7,
                  _vm.stats[_vm.user_id].emails_sent_7
                ),
                _vm.getPercentage(
                  _vm.stats[_vm.user_id].bounce_total_15,
                  _vm.stats[_vm.user_id].emails_sent_15
                )
              ),
              true
            )},[_vm._v("\n          "+_vm._s(_vm.calcKPI(
              _vm.getPercentage(
                _vm.stats[_vm.user_id].bounce_total_7,
                _vm.stats[_vm.user_id].emails_sent_7
              ),
              _vm.getPercentage(
                _vm.stats[_vm.user_id].bounce_total_15,
                _vm.stats[_vm.user_id].emails_sent_15
              )
            ))+"%\n        ")]):_vm._e()])]):_vm._e(),(_vm.type == 'statsnow')?_c('span',[_c('i',{staticClass:"icon-send text-success"}),_vm._v(_vm._s(_vm.stats[_vm.user_id].emails_sent)+",\n      "),_c('i',{staticClass:"icon-close text-danger"}),_vm._v(_vm._s(_vm.stats[_vm.user_id].bounce_total)+",\n      "),_c('i',{staticClass:"icon-eye text-primary"}),_vm._v(_vm._s(_vm.stats[_vm.user_id].emails_opened)+"\n    ")]):_vm._e(),(_vm.type == 'emailsopen')?_c('span',{},[_vm._v(_vm._s(_vm.getPercentage(
          _vm.stats[_vm.user_id].emails_opened,
          _vm.stats[_vm.user_id].emails_sent_b
        ))+"%\n      "),_c('div',[(
            _vm.calcKPI(
              _vm.getPercentage(
                _vm.stats[_vm.user_id].emails_opened_7,
                _vm.stats[_vm.user_id].emails_sent_b_7
              ),
              _vm.getPercentage(
                _vm.stats[_vm.user_id].emails_opened_15,
                _vm.stats[_vm.user_id].emails_sent_b_15
              )
            ) != 0
          )?_c('div',{class:_vm.getColorKPI(
              _vm.calcKPI(
                _vm.getPercentage(
                  _vm.stats[_vm.user_id].emails_opened_7,
                  _vm.stats[_vm.user_id].emails_sent_b_7
                ),
                _vm.getPercentage(
                  _vm.stats[_vm.user_id].emails_opened_15,
                  _vm.stats[_vm.user_id].emails_sent_b_15
                )
              )
            )},[_vm._v("\n          "+_vm._s(_vm.calcKPI(
              _vm.getPercentage(
                _vm.stats[_vm.user_id].emails_opened_7,
                _vm.stats[_vm.user_id].emails_sent_b_7
              ),
              _vm.getPercentage(
                _vm.stats[_vm.user_id].emails_opened_15,
                _vm.stats[_vm.user_id].emails_sent_b_15
              )
            ))+"%\n        ")]):_vm._e()])]):_vm._e(),(_vm.type == 'avday')?_c('span',{},[_vm._v(_vm._s(parseFloat(_vm.stats[_vm.user_id].avday).toFixed(2)))]):_vm._e(),(_vm.type == 'events')?_c('span',{},[_vm._v(_vm._s(_vm.getPercentage(_vm.stats[_vm.user_id].events, _vm.stats[_vm.user_id].emails_sent_b))+"%\n      "),_c('div',[(
            _vm.calcKPI(
              _vm.getPercentage(
                _vm.stats[_vm.user_id].events_7,
                _vm.stats[_vm.user_id].emails_sent_b_7
              ),
              _vm.getPercentage(
                _vm.stats[_vm.user_id].events_15,
                _vm.stats[_vm.user_id].emails_sent_b_15
              )
            ) != 0
          )?_c('div',{class:_vm.getColorKPI(
              _vm.calcKPI(
                _vm.getPercentage(
                  _vm.stats[_vm.user_id].events_7,
                  _vm.stats[_vm.user_id].emails_sent_b_7
                ),
                _vm.getPercentage(
                  _vm.stats[_vm.user_id].events_15,
                  _vm.stats[_vm.user_id].emails_sent_b_15
                )
              )
            )},[_vm._v("\n          "+_vm._s(_vm.calcKPI(
              _vm.getPercentage(
                _vm.stats[_vm.user_id].events_7,
                _vm.stats[_vm.user_id].emails_sent_b_7
              ),
              _vm.getPercentage(
                _vm.stats[_vm.user_id].events_15,
                _vm.stats[_vm.user_id].emails_sent_b_15
              )
            ))+"%\n        ")]):_vm._e()])]):_vm._e(),(_vm.type == 'valid')?_c('span',{staticClass:"text-success"},[_vm._v(_vm._s(_vm.stats[_vm.user_id].events_total - _vm.stats[_vm.user_id].absent - _vm.stats[_vm.user_id].canceled))]):_vm._e(),(_vm.type == 'absent' && _vm.stats[_vm.user_id].absent > 0)?_c('span',{staticClass:"text-warning"},[_vm._v(_vm._s(_vm.stats[_vm.user_id].absent))]):_vm._e(),(_vm.type == 'canceled' && _vm.stats[_vm.user_id].canceled > 0)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.stats[_vm.user_id].canceled))]):_vm._e(),(_vm.type == 'spam_rate')?_c('span',{class:_vm.getSpamRateClass(_vm.stats[_vm.user_id].spam_rate)},[_vm._v("\n      "+_vm._s(parseFloat(_vm.stats[_vm.user_id].spam_rate).toFixed(2))+"%\n      "),_c('div',[(
            _vm.calcKPI(
              parseFloat(_vm.stats[_vm.user_id].spam_rate).toFixed(2),
              parseFloat(_vm.stats[_vm.user_id].spam_rate_7).toFixed(2)
            ) != 0
          )?_c('div',{class:_vm.getColorKPI(
              _vm.calcKPI(
                parseFloat(_vm.stats[_vm.user_id].spam_rate).toFixed(2),
                parseFloat(_vm.stats[_vm.user_id].spam_rate_7).toFixed(2)
              ),
              true
            )},[_vm._v("\n          "+_vm._s(_vm.calcKPI(
              parseFloat(_vm.stats[_vm.user_id].spam_rate).toFixed(2),
              parseFloat(_vm.stats[_vm.user_id].spam_rate_7).toFixed(2)
            ))+"%\n        ")]):_vm._e()])]):_vm._e()],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }